export const patterns = {
  h1: /^# (.*$)/gim,
  h2: /^## (.*$)/gim,
  h3: /^### (.*$)/gim,
  h4: /^#### (.*$)/gim,
  h5: /^##### (.*$)/gim,
  code: /`(.*?)`/gim,
  strong: /\*\*(.*?)\*\*/gim,
  em: /\*(.*?)\*/gim,
  link: /(?<!\!)\[([^\]]+)\]\(([^)]+)\)/gim,
  unorderedList: /((?:^[\s]*[-*+]\s+.+(?:\n|$))+)/gim,
  unorderedListItem: /^[\s]*[-*+]\s+(.+)/gim,
  orderedList: /((?:^[\s]*\d+\.\s+.+(?:\n|$))+)/gim,
  orderedListItem: /^[\s]*\d+\.\s+(.+)/gim,
  linkWithTitle: /\[([^\]]*)\]\(([^\s"]+)\s+"([^"]*)"\)/g, // [xxxx](id "title")
  linkWithId: (id: string) =>
    new RegExp(`\\[([^\\]]*)\\]\\(${id}\\s+"([^"]*)"\\)`, 'g'),
  blankLine: /\n\n+/gim,
  codeBlock: /```(\w*)\n?([\s\S]*?)```/gim,
  leadingAndTrailingWhitespace: /^\s*\n([\s\S]*?)\n\s*$/g,
  validUrl:
    /(?<!\]\()https?:\/\/(?:[-\w.])+(?:\:[0-9]+)?(?:\/(?:[\w\/_.])*)?(?:\?(?:[\w&=%.])*)?(?:\#(?:[\w.])*)?/gim,
  headings: /^(#{1,6})\s/gim, // highlight h1 to h6
  escapedHeadings: '\\$1 ',
  preCodeBlock:
    /^<pre(?:\s+[^>]*)?><code(?:\s+[^>]*)?>([\s\S]*?)<\/code><\/pre>$/gim, // wrapped in <pre><code></code></pre>
};
